import React, { useState } from "react";

import { PageLoader, Typography } from "clearsense-ui/components";
import ExploreContainer from "components/Common/ExploreContainer";
import FilterHeader from "components/Common/FilterHeader";
import { useUserState } from "contexts/user";
import { useColumnHeaderSelector } from "hooks/useColumnHeaderSelector";
import { getPermissions } from "utils/roleBasedAccess";

import DeleteDomain from "./DeleteDomains";
import DomainsTable from "./Table";

import { DOMAINS_COLUMNS, DOMAINS_DATA } from "../../constants/domainsExplore";
import PeopleSummaryCard from "../PeopleSummaryCard";

const Domains = ({ features, steward }) => {
  const user = useUserState();
  const userPermissions = getPermissions(features, user?.role);

  const [checkedRows, setCheckedRows] = useState([]);
  const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const columnHeaderSelector = useColumnHeaderSelector(DOMAINS_COLUMNS());
  return (
    <ExploreContainer>
      <div className="flex justify-between">
        <Typography style="h3" type="semibold">
          Domains for {steward.name} (2)
        </Typography>
        <div className="m-auto">
          <Typography style="h3" type="semibold">
            Summary
          </Typography>
        </div>
      </div>
      <PeopleSummaryCard steward={steward} />
      <FilterHeader
        entity="Domains"
        filterParams={{ setSearch: () => {} }}
        columnHeaderSelector={columnHeaderSelector}
        count={2}
        checkedRows={checkedRows}
        setIsDeleteAlertOpen={setIsDeleteAlertOpen}
        userPermissions={userPermissions}
      />
      {isLoading ? (
        <PageLoader />
      ) : (
        <DomainsTable
          userPermissions={userPermissions}
          columns={columnHeaderSelector.columns}
          domains={DOMAINS_DATA}
          domainsLength={DOMAINS_DATA.length}
          setCheckedRows={setCheckedRows}
          checkedRows={checkedRows}
          data-cy="domains-table"
        />
      )}
      <DeleteDomain
        checkedRows={checkedRows}
        setCheckedRows={setCheckedRows}
        isDeleteAlertOpen={isDeleteAlertOpen}
        setIsDeleteAlertOpen={setIsDeleteAlertOpen}
        setIsLoading={setIsLoading}
      />
    </ExploreContainer>
  );
};

export default Domains;
